import ThSorted from "../Table/ThSorted";
import LoanRow from "./LoanRow";
import { useTranslation } from "../../hooks/useTranslation";

export default function LoanTable({
                                         awailableColumns,
                                         selectedColumns,
                                         loans,
                                         sortTable,
                                         setSortTable,
                                     }) {
    const { t } = useTranslation();

    return (
        <>
            <div
                id="kt_customers_table_wrapper"
                className="dt-container dt-bootstrap5 dt-empty-footer"
            >
                <div id="" className="table-responsive">
                    <table
                        className="table align-middle table-row-dashed fs-6 gy-5 dataTable"
                        id="kt_customers_table"
                        style={{width: "100%"}}
                    >
                        <thead>
                        <tr className="text-start fw-bold fs-7 text-uppercase gs-0">
                            {Object.keys(awailableColumns)
                                .filter((awailableColumnsKey) =>
                                    selectedColumns.includes(awailableColumnsKey)
                                )
                                .map((awailableColumnsKey, th_key) => (
                                    <ThSorted
                                        key={th_key}
                                        awailableColumns={awailableColumns}
                                        awailableColumnsKey={awailableColumnsKey}
                                        sortTable={sortTable}
                                        setSortTable={setSortTable}/>
                                ))}
                            <th
                                className="min-w-150px dt-orderable-asc dt-orderable-desc text-end"
                                data-dt-column="2"
                                rowSpan="1"
                                colSpan="1"
                                aria-label="Email: Activate to sort"
                                tabIndex="0"
                            >
                                  <span className="dt-column-title" role="button">
                                    {t("common.actions")}
                                  </span>
                                <span className="dt-column-order"></span>
                            </th>
                        </tr>
                        </thead>
                        <tbody className="fw-semibold text-gray-600">
                        {loans?.data?.length > 0 &&
                            loans.data?.map((loan, loan_key) => (
                                <LoanRow
                                    key={loan_key}
                                    loan={loan}
                                    awailableColumns={awailableColumns}
                                    selectedColumns={selectedColumns}
                                />
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}
